import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const DeleteJivoWidgetContentType = '' as const;
export type DeleteJivoWidgetRequest = void;
export type DeleteJivoWidgetResponses = LinkCommonErrorResponses & {
    /**
     * @description Jivo widget deleted successfully
     */
    '200': {};
};
export type DeleteJivoWidgetResponseSuccess = undefined;
export type DeleteJivoWidgetSearchParams = undefined;
export type DeleteJivoWidgetPathParameters = undefined;
export const DeleteJivoWidgetUrl = '/integrations/jivo/widget' as const;
export const DeleteJivoWidgetMethod = 'DELETE' as const;
export const getDeleteJivoWidgetUrl = (_params?: DeleteJivoWidgetPathParameters) => DeleteJivoWidgetUrl;
